import { render, staticRenderFns } from "./v_Terms.vue?vue&type=template&id=0b020820&scoped=true&"
import script from "./v_Terms.vue?vue&type=script&lang=js&"
export * from "./v_Terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b020820",
  null
  
)

export default component.exports